import { useEffect, useState } from "react";
import { getLoanList } from "../Services/PayrollService";
import { date } from "yup";

export const MyLoans = ({ showTab, hideAmount }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  // const [showStmt, setShowStmt] = useState(false);
  const [loanList, setLoanList] = useState([]);

  useEffect(() => {
    fetchLoanList();
  }, []);

  const renderAmt = (value) => {
    return hideAmount ? "•••••" : `₹${value.toLocaleString("en-IN")}`;
    // if (masked) {
    //   return <span style={{ letterSpacing: '2px' }}>••••••</span>;
    // }
    // return `₹${value.toLocaleString('en-IN')}`;
  };

  async function fetchLoanList() {
    const req = {
      LoanId: 0,
      LoggedInEmpId: userDetails.EmpId || 0,
      OrgId: userDetails.OrgId || 0,
      GUID: "",
      EmpId: userDetails.EmpId || 0,
      PageNumber: 1,
      PageSize: 25,
      Search: "",
      LoanStatusId: "",
      LoanTypeId: "",
    };

    try {
      const response = await getLoanList(req);

      setLoanList(
        response?.Data?.LoanItems.map((loan) => {
          return {
            ...loan,
            showStmt: false,
          };
        }) || [],
      );
      console.log(response, "response-----------");
    } catch (error) {
      console.error("Error fetching loan list:", error);
    }
  }

  return (
    <div className="tab-panel active" id="tab-loans">
      <div className="emi-alert no-print">
        <i
          className="fa-solid fa-bell"
          style={{ color: "var(--brand)", fontSize: "16px", flexShrink: 0 }}
        />
        <div>
          Next EMI of <strong>{renderAmt(5000)}</strong> for Personal Loan will
          be deducted in <strong>April 2025</strong> payroll.
        </div>
      </div>

      {loanList.length > 0 &&
        loanList.map((loan, idx) => (
          <div className="sec-card" key={idx}>
            <div className="sec-card-head">
              <i className="fa-solid fa-hand-holding-dollar text-brand" />
              <h6>{loan?.LoanTypeName}</h6>
              <div
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <span className="badge badge-active">
                  {loan?.LoanStatusName}
                </span>
                <button
                  className="btn btn-light btn-sm no-print"
                  onClick={() => {
                    loan.showStmt = !loan.showStmt;
                    setLoanList([...loanList]);
                  }}
                >
                  <i className="fa-solid fa-file-lines" /> Repayment Schedule
                </button>
                <button
                  className="btn btn-light btn-sm no-print"
                  onClick={() => window.print()}
                >
                  <i className="fa-solid fa-print" /> Print
                </button>
              </div>
            </div>
            <div className="sec-card-body">
              <div
                style={{
                  fontSize: "12px",
                  color: "var(--text-muted)",
                  marginBottom: "14px",
                }}
              >
                Disbursed:{" "}
                {loan?.DisbursedOn
                  ? new Date(loan.DisbursedOn).toLocaleDateString()
                  : "-"}{" "}
                &nbsp;&bull;&nbsp; Tenure: {loan?.Tenure || "0"}{" "}
                {loan?.Tenure > 1 ? "months" : "month"} &nbsp;&bull;&nbsp; First
                deduction: {loan?.FirstDeductionMonth}
              </div>

              <div className="loan-stats">
                <div>
                  <div className="ls-label">Loan Amount</div>
                  <div className="ls-val">
                    {renderAmt(loan?.LoanAmount || 0)}
                  </div>
                </div>
                <div>
                  <div className="ls-label">Total Repaid</div>
                  <div className="ls-val" style={{ color: "var(--success)" }}>
                    {renderAmt(loan?.Repaid || 0)}
                  </div>
                </div>
                <div>
                  <div className="ls-label">Outstanding</div>
                  <div className="ls-val" style={{ color: "#92400e" }}>
                    {renderAmt(loan?.Outstanding || 0)}
                  </div>
                </div>
                <div>
                  <div className="ls-label">Monthly EMI</div>
                  <div className="ls-val">
                    {renderAmt(loan?.MonthlyEMI || 0)}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "4px",
                }}
              >
                <div className="pbar-wrap" style={{ flex: 1 }}>
                  <div className="pbar-fill" style={{ width: "46%" }} />
                </div>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 700,
                    color: "var(--brand)",
                    whiteSpace: "nowrap",
                  }}
                >
                  46% repaid &nbsp;&bull;&nbsp; {loan?.RemainingEMIs} EMIs remaining
                </span>
              </div>

              {/* Repayment Schedule */}
              {loan?.showStmt && (
                <div
                  id="stmtWrap"
                  style={{
                    marginTop: "18px",
                    borderTop: "1px solid var(--border)",
                    paddingTop: "16px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      color: "var(--text-mid)",
                      textTransform: "uppercase",
                      letterSpacing: ".4px",
                      marginBottom: "10px",
                    }}
                  >
                    Full Repayment Schedule
                  </div>
                  <div style={{ overflowX: "auto" }}>
                    <table className="stmt-tbl">
                      <thead>
                        <tr>
                          <th style={{ textAlign: "left", width: "32px" }}>
                            #
                          </th>
                          <th style={{ textAlign: "left" }}>Month</th>
                          <th className="tr">Opening Balance</th>
                          <th className="tr">EMI</th>
                          <th className="tr">Closing Balance</th>
                          <th style={{ textAlign: "center" }}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* You can expand this with full JS logic if needed. For now, keeping simple */}
                        <tr className="row-current">
                          <td
                            style={{
                              fontSize: "11px",
                              color: "var(--text-muted)",
                            }}
                          >
                            12
                          </td>
                          <td>Apr 2025</td>
                          <td className="tr">₹65,000</td>
                          <td className="tr">₹5,000</td>
                          <td className="tr">₹60,000</td>
                          <td style={{ textAlign: "center" }}>
                            <span
                              className="badge badge-pending"
                              style={{ fontSize: "10px" }}
                            >
                              <i className="fa-solid fa-circle-dot" /> Current
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}

      {/* <div
        style={{
          padding: "14px 0",
          borderTop: "1px solid var(--border)",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
          Coming in a future phase:
        </span>
        <span className="future-btn" style={{ width: "auto", marginBottom: 0 }}>
          <i className="fa-solid fa-plus" /> Request Loan / Advance
        </span>
      </div> */}
    </div>
  );
};

export default MyLoans;
